'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function isFutureDate(date, now = new Date()) {
  return now < date;
}

exports.isFutureDate = isFutureDate;
